
import { mapState } from 'vuex';
import HorizontalScroll from './components/HorizontalScroll.vue';

export default {
  i18nComponentKey: 'WidgetProductReviewsHorizontalScroll.WidgetProductReviewsHorizontalScrollPc',
  name: 'WidgetProductReviewsHorizontalScrollPc',
  components: { HorizontalScroll },
  computed: {
    ...mapState('widget', ['widget'])
  }
};
